import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

// constants
import {
    FormulaCategory,
    FormulaDetailModel,
} from '../../models/formula.model';

import API from '../../services/api';

// hooks
import useAnalytics from '../helper/useAnalytics';
import formulaKeys from './_queryKeys';

const useFormulaDelete = () => {
    const queryClient = useQueryClient();
    const catalogKey = ['formulaCatalog', FormulaCategory.Draft];

    const { track } = useAnalytics();

    return useMutation<AxiosResponse<FormulaDetailModel>, BaseError, number>({
        mutationFn: API.deleteFormula,
        onMutate: async (formulaId) => {
            const previousFormulas = await queryClient.getQueryData(catalogKey);
            queryClient.setQueryData(catalogKey, (previousData: any) => {
                if (previousData) {
                    previousData.Draft = previousData.Draft.filter(
                        (formula: FormulaDetailModel) =>
                            formulaId !== formula.id,
                    );
                }
                return previousData;
            });
            return { previousFormulas };
        },
        onError: (err, newFormula, context: any) => {
            queryClient.setQueryData(catalogKey, context.previousFormulas);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        },
        onSuccess: (data, formulaId) => {
            track('formula_deleted', {
                formulaId,
            });
        },
    });
};

export default useFormulaDelete;
